import { render, staticRenderFns } from "./PasswordResetEmail.vue?vue&type=template&id=23918414&scoped=true&"
import script from "./PasswordResetEmail.vue?vue&type=script&lang=js&"
export * from "./PasswordResetEmail.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetEmail.vue?vue&type=style&index=0&id=23918414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23918414",
  null
  
)

export default component.exports